<template>
  <v-alert
    v-if="shouldShow && missingScopes.length > 0"
    type="info"
    prominent
    class="mb-4 pl-6"
  >
    <div class="d-flex align-center">
      <div>
        <p class="mb-0">Your Shopify connection is missing permissions needed for full functionality:</p>
        <ul class="mb-0 mt-2">
          <li v-for="scope in missingScopes" :key="scope.handle">
            <strong>{{ scope.handle }}</strong> — {{ scope.description }}
          </li>
        </ul>
      </div>
      <v-spacer />
      <v-btn color="primary" :href="updateUrl" :loading="loading" large>
        Update
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
// Required scopes (matches server/src/shopify/lib/scopes.js)
const EXTENDED_SCOPES = [
  'write_content', 'write_files', 'write_products', 'write_themes',
  'read_publications', 'write_publications', 'read_online_store_navigation',
  'read_orders'
]

const SCOPE_METADATA = {
  'read_orders': {
    description: 'Required for revenue attribution'
  }
}

export default {
  data: () => ({
    loading: false,
    currentScopes: null
  }),

  computed: {
    accountId() {
      return this.$store.getters.account?.id
    },
    shopifyIntegration() {
      return this.$store.getters.shopifyIntegration
    },
    shouldShow() {
      // Only show for account 85 (Cozy) with OAuth connection
      if (this.accountId !== 85) return false
      if (!this.shopifyIntegration?.active) return false
      const publicData = this.shopifyIntegration.public || {}
      return publicData.type === 'OAUTH'
    },
    missingScopes() {
      if (!this.currentScopes) return []
      return EXTENDED_SCOPES
        .filter(s => !this.currentScopes.includes(s))
        .filter(s => SCOPE_METADATA[s]) // Only show scopes we have metadata for
        .map(s => ({ handle: s, ...SCOPE_METADATA[s] }))
    },
    updateUrl() {
      if (!this.shopifyIntegration?.id) return '#'
      return `/api/integration/${this.shopifyIntegration.id}/request/enableAnalytics`
    }
  },

  watch: {
    shouldShow: {
      immediate: true,
      handler(val) {
        if (val) this.fetchScopes()
      }
    }
  },

  methods: {
    async fetchScopes() {
      if (!this.shopifyIntegration?.id) return
      this.loading = true
      try {
        const response = await this.$http.get(
          `/api/integration/${this.shopifyIntegration.id}/request/accessScopes`
        )
        this.currentScopes = response.data || []
      } catch (e) {
        console.error('Failed to fetch scopes:', e)
        this.currentScopes = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
